import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import Text from '../Text';
import properties from '../../../modules/ajio-util/properties';
import { createCookie } from '../../../components/common/Cookie';

const cx = classNames.bind(styles);

export interface SwatchProps {
  swipeClickEvent?: (A: Record<string, string>) => void;
}

const SwipeIcon = (props: SwatchProps) => {
  const imageBaseUrl = properties.getProperty('imageBaseUrl');

  return (
    <div className={cx('swipe-view')}>
      <img src={`${imageBaseUrl}/static/img/swipe.svg`} alt="Swipe icon" />
      <Text variant="T4" weight="bold" color="White" customClass={cx('swipe-label')}>
        Swipe for next look
      </Text>
    </div>
  );
};

export default SwipeIcon;
